import { Alert } from '@skupreme/shared/ui';
import { brand } from '@utility/config';
import { CommonUtility } from '@utility/common';
import ListService from '@utility/services/list';
import { useEffect, useState } from 'react';
import { LocationMarket } from './LocationMarket';

export function ConnectedMarkets({
  connectedMarketPlaces,
  connectedAds = [],
  continents,
  isUser,
  updateCredentials,
  doProgressSync = true,
  disconnectMarket,
  reconnect,
  refreshMetadata,
}) {
  const [countries, setCountries] = useState([]);
  const [showSync, setShowSync] = useState(true);

  let seedConnected = CommonUtility.isValidArray(connectedMarketPlaces)
    ? // @ts-expect-error - TS18046: 'marketplace' is of type 'unknown'.
      connectedMarketPlaces.filter(marketplace => marketplace.is_seed)
    : [];

  useEffect(() => {
    const getCountries = async () => {
      const data = await ListService.country();
      setCountries(data);
    };
    getCountries();
  }, []);

  seedConnected = seedConnected.filter(
    (marketPlace, index, self) =>
      // @ts-expect-error - TS18046: 't' is of type 'unknown'.
      index === self.findIndex(t => t.type === marketPlace.type),
  );

  return (
    <div className="sk:mb-11 sk:flex sk:w-full sk:min-w-0 sk:flex-col sk:gap-4">
      {/* @ts-expect-error - TS2339: Property 'type' does not exist on type '{}'. */}
      {showSync && seedConnected?.[0]?.type && (
        <Alert tone="info" onDismiss={() => setShowSync(false)}>
          Your product information is synced in Price-Quantity Sync.{' '}
          {brand.name} takes changes made on your seed marketplace (
          {/* @ts-expect-error - TS2339: Property 'type' does not exist on type '{}'. */}
          {seedConnected?.[0]?.type}) and syncs them across all of your
          marketplaces.
        </Alert>
      )}
      {CommonUtility.isValidArray(continents) &&
        continents.map(d => (
          <LocationMarket
            // @ts-expect-error - TS2322: Type 'unknown' is not assignable to type 'Key | null | undefined'.
            key={d}
            title={d}
            refreshMetadata={refreshMetadata}
            connectedMarketPlaces={connectedMarketPlaces}
            connectedAds={connectedAds}
            isUser={isUser}
            updateCredentials={updateCredentials}
            doProgressSync={doProgressSync}
            disconnectMarket={disconnectMarket}
            reconnect={reconnect}
            countries={countries}
          />
        ))}
    </div>
  );
}
